module.exports = __webpack_public_path__ + "img/logo_text_white.3ae42bfc.svg";